














import { Component, Prop, Vue } from "vue-property-decorator";
import FscModal from "@/components/Modal/FscModal.vue";

@Component({
  components: { FscModal },
})
export default class ConfirmTuvSyncModal extends Vue {
  public name = "ConfirmTuvSyncModal";

  @Prop({ type: String })
  public modalId!: string;

  @Prop({ type: String })
  public tuevSystem!: string;

  get isTuevSUD() {
    return this.tuevSystem == "SUD";
  }
}
